import { AccountObjectApiFacade } from "../account-object/account-object.api-facade";
import { AccountStatistics, IAccountStatistics } from "./account-statistics.model";
import { ApiRequestOptions } from "../../../core/services/api/request-options";
import { Observable } from "rxjs/Observable";

export class AccountStatisticsApiFacade extends AccountObjectApiFacade<AccountStatistics> {
    get(accountId: string, id: string, options?: ApiRequestOptions): Observable<AccountStatistics> {
        return this.GET(`/accounts/${accountId}/statistics/${id}`, options)
            .map(object => new AccountStatistics(object));
    }

    getAll(accountId: string, options?: ApiRequestOptions): Observable<Array<AccountStatistics>> {
        return this.GET(`/accounts/${accountId}/statistics`, options)
            .map(object => [AccountStatistics.makeModelFromApiResponse(object as IAccountStatistics, accountId)]);
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/account-statistics/account-statistics.api-facade.ts